import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Dropdown } from 'semantic-ui-react'
import $ from "jquery";
import _ from 'lodash';
import Loading from '../loading';
import Server from '../../functions/server';
import Permission from '../../functions/permission';
import Menus from './menu';
import Home from './home';
import Drawer from '../drawer/drawer';
import domainName from '../../functions/domainName';
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  }
});

class ButtonAppBar extends React.Component {

  state = {
    data: null,
    datas: '',
    load: false,
    message: '',
    spareOption: [],
    spare: null,
    leading: false,
    title: 'Add Parts',
    viewEdit: '', menuPermission: []
  }

  componentDidMount() {
    this.menuControl()
  }

  menuControl() {
    let menuPermission = Permission('add-parts', this.props.menus);
    if (menuPermission.view) {
        this.getParts();
    }
    this.setState({ menuPermission })
  }

  getParts() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Spares!!!'
    });
    let data1 = {};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getspares.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setSpares(data);
        } catch (e) {
          alert('Error!!')
        }
      },
      error: function(err)
      {
        console.log(err);
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setSpares(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      let name = y.partno + '->' + y.spare_name;
      x.push({key: name, text: name, value: y.partno});
    });
    try {
      context.setState({
        spareOption: x,
        datas: data
      });
    } catch (e) {

    }
  }

  getData(value, title, tax) {
    this.getParts();
    this.setState({
      title: title,
      value: value,
      tax: tax,
    })
  }

  logout() {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    window.location.assign(domainName());
  }

  render() {
    const { classes } = this.props;
    let { load, message, dropdown } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div className={classes.root}>
        { this.state.menuPermission.view ?
          (
            <div>
                <AppBar position="static" style={{backgroundColor: '#abb119'}}>
                <Toolbar>
                  <Drawer />
                  <Typography variant="h6" color="inherit" className={classes.grow}>
                    {this.state.title}
                  </Typography>
                  <div style={{marginRight: 10}}>
                    <Menus menuPermission={this.state.menuPermission} menus={this.props.menus} partsedit={this.state.partsedit} datas={this.state.datas} partsedit={this.state.partsedit} spareOption={this.state.spareOption} /></div>
                    <Button variant="outlined" color="inherit" onClick={this.logout.bind(this)}>
                      Logout
                    </Button>
                </Toolbar>
              </AppBar>
              <Home tax={this.state.tax} getData={this.getData.bind(this)} datas={this.state.datas} menuPermission={this.state.menuPermission} menus={this.props.menus}/>
              {loading}
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);
